// Central content for Fabion Kallaku's media kit.
// Info sourced from the Notion media kit; pricing from the rate card.

export const PROFILE = {
  name: "Fabion Kallaku",
  role: "AI Content Creator & Strategist",
  headline: "Making AI practical for millions.",
  bio: "I create short-form content that makes AI practical, entertaining, and easy to understand for millions of people. My audience includes everyday consumers curious about emerging technology, as well as founders, marketers, creators, and business owners looking to use AI to grow faster and work more efficiently.",
  image: "https://customer-assets.emergentagent.com/job_brand-collab-28/artifacts/9o8bm0e4_1772573945888.jpeg",
  email: "pr@fabionkallaku.com",
  phone: "+1 (415) 378-3882",
  socials: {
    instagram: "https://www.instagram.com/fabionkallaku/",
    linkedin: "https://www.linkedin.com/in/fabion-kallaku-95333a294/",
    youtube: "https://www.youtube.com/@fabionkallaku",
  },
  platforms: ["Instagram", "LinkedIn", "YouTube"],
};

export const STATS = [
  { label: "Followers across socials", value: "250K+", span: "md:col-span-5 md:row-span-2", size: "big" },
  { label: "Total views generated", value: "100M+", span: "md:col-span-7" },
  { label: "Views on sponsored content", value: "10M+", span: "md:col-span-4" },
  { label: "Sign-up conversions driven", value: "10,000+", span: "md:col-span-3" },
  { label: "Views on pre-made ads content", value: "30M+", span: "md:col-span-7", note: "Brand content run on paid ads" },
];

export const DEMOGRAPHICS = {
  Location: [
    { label: "North America", value: 40 },
    { label: "Europe", value: 25 },
    { label: "Asia / Other", value: 35 },
  ],
  Gender: [
    { label: "Men", value: 70 },
    { label: "Women", value: 30 },
  ],
  Age: [
    { label: "18–24", value: 32 },
    { label: "25–34", value: 37 },
    { label: "35+", value: 31 },
  ],
};

export const BRANDS = [
  "ElevenLabs", "ClickUp", "Accio by Alibaba", "LumaLabs", "Higgsfield",
  "N8N", "InVideo", "Creatify", "Descript", "Runway", "Emergent",
  "Kickresume", "Magical", "Wix Studio",
];

export const CASE_STUDIES = [
  {
    brand: "OpenAI",
    type: "AI Product Content",
    description: "AI Product Content",
    link: "https://www.instagram.com/reel/DcjIV1-K8e8/",
  },
  {
    brand: "Higgsfield",
    type: "AI Video Campaign",
    description: "AI Video Campaign",
    link: "https://www.instagram.com/reel/DdHv468K5AI/",
  },
  {
    brand: "Descript",
    type: "Integration",
    description: "A 2-part talking-head series designed to convert cold viewers, promoted across Descript's paid advertising channels.",
    metrics: [
      { label: "People reached", value: "1M" },
      { label: "New sign-ups", value: "1,000" },
    ],
  },
];

export const FEATURED_WORK = [
  { title: "Utopai Studios", link: "https://www.instagram.com/reel/DXexg1_Cjum/" },
  { title: "Google Omni Launch", link: "https://www.instagram.com/reel/DZpxx96K8Dw/" },
  { title: "Descript", link: "https://www.instagram.com/reel/DR4zUFtCjR-/" },
  { title: "ImagineArt", link: "https://www.instagram.com/reel/DMH4OejCxeH/" },
];

export const WHY_CHOOSE = [
  "Audience actively uses and pays for AI tools",
  "Proven history with AI, SaaS, and tech companies",
  "Workflow-based integrations, not shallow shout-outs",
  "Content built to drive measurable action",
  "Strong trust positioning with a loyal audience",
  "Creator + strategist mindset",
  "Premium, cinematic production quality",
  "Selective partnerships & long-term focus",
];

export const SPECIAL_BUNDLE = {
  title: "The Special Bundle",
  subtitle: "Maximum impact — production, distribution, and long-term amplification in one.",
  priceRegular: "$9,000",
  priceDiscounted: "$6,000",
  savings: "Save $3,000 — one-time offer",
  includes: [
    "1x High-Production Reel",
    "1x Integration",
    "1x Story with a Link",
    "Strategy Consultation",
    "Lifetime Paid Ads Usage for the Video",
    "Link in Bio — 7 Days",
  ],
};

export const ALT_PACKAGE = {
  title: "Reel + Paid + Story",
  subtitle: "A focused campaign built for reach and retention.",
  priceRegular: "$5,000",
  priceDiscounted: "$4,000",
  savings: "Save $1,000",
  includes: [
    "1x Instagram Reel (crossposted on TikTok)",
    "30 days Paid Ads Usage",
    "1x Story",
  ],
};

export const A_LA_CARTE = [
  { service: "1x Reel", price: "$3,000" },
  { service: "1x Carousel", price: "$2,000" },
  { service: "Dedicated YouTube Video", price: "$1,000" },
  { service: "1x Story", price: "$500" },
  { service: "Casual Mention", price: "$400" },
];

export const USAGE_RIGHTS = [
  { service: "Paid Ads Usage", price: "$1,000 / month", subtitle: "Paid advertising rights billed monthly." },
  { service: "Exclusivity Rights", price: "On request", subtitle: "Custom pricing based on scope and duration." },
  { service: "Organic Usage (Non-Paid)", price: "On request" },
];
